import { SVGProps, memo } from 'react';

const TxtIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x='2.19043' y='2.63232' width='20' height='3' fill='#212121' />
    <rect x='2.19043' y='18.6323' width='20' height='3' fill='#212121' />
    <path
      d='M15.8309 10.6689V9.42432H21.1899V10.6689H19.2673V15.7646H17.7566V10.6689H15.8309Z'
      fill='#212121'
    />
    <path
      d='M11.0032 9.42432L12.161 11.4273H12.2105L13.3808 9.42432H15.0959L13.1826 12.5945L15.1578 15.7646H13.3994L12.2105 13.7399H12.161L10.9722 15.7646H9.22614L11.192 12.5945L9.27567 9.42432H11.0032Z'
      fill='#212121'
    />
    <path
      d='M3.19495 10.6689V9.42432H8.55388V10.6689H6.63135V15.7646H5.12057V10.6689H3.19495Z'
      fill='#212121'
    />
  </svg>
);

export default memo(TxtIcon);
